import React from "react";
import AsyncSearchSelect from "./AsyncSearchSelect";
import lookupService from "../services/lookupService";

const chargeTypes = [
  { value: "", label: "Not Applicable" },
  { value: "FREIGHT", label: "Freight" },
  { value: "LOADING", label: "Loading" },
  { value: "UNLOADING", label: "Unloading" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "PACKING", label: "Packing" },
  { value: "OTHER", label: "Other" }
];

const payerTypes = [
  { value: "COMPANY", label: "Company" },
  { value: "VENDOR", label: "Vendor" },
  { value: "CUSTOMER", label: "Customer" }
];

const POChargeTable = ({
  charges,
  setCharges
}) => {

  const addRow = () => {
    setCharges([
      ...charges,
      {
        charge_type: "",
        payer_type: "COMPANY",
        customer_id: "",
        customer_name: "",
        charge_amount: 0,
        gst_rate: 0,
        remarks: ""
      }
    ]);
  };

  const removeRow = (index) => {
    const updated = [...charges];
    updated.splice(index, 1);
    setCharges(updated);
  };

  const updateRow = (
    index,
    field,
    value
  ) => {
    const updated = [...charges];

    updated[index][field] = value;

    setCharges(updated);
  };

  return (
    <div className="mt-4">

      <div className="d-flex justify-content-between mb-2">
        <h6>Additional Charges</h6>

        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={addRow}
        >
          Add Charge
        </button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Charge Type</th>
            <th>Payer</th>
            <th>Customer</th>
            <th>GST %</th>
            <th>Amount</th>
            <th>Remarks</th>
            <th width="80">Action</th>
          </tr>
        </thead>

        <tbody>

          
          {charges.length === 0 && (
                <tr>
                    <td colSpan="7" className="text-center">
                        No additional charges added
                    </td>
                </tr>
            )}
          {charges.map((row, index) => (

            <tr key={index}>

              <td>
                <select
                  className="form-control"
                  value={row.charge_type}
                  onChange={(e) =>
                    updateRow(
                      index,
                      "charge_type",
                      e.target.value
                    )
                  }
                >
                  {chargeTypes.map((c) => (
                    <option
                      key={c.value}
                      value={c.value}
                    >
                      {c.label}
                    </option>
                  ))}
                </select>
              </td>

              <td>
                <select
                  className="form-control"
                  value={row.payer_type}
                  onChange={(e) =>
                    updateRow(
                      index,
                      "payer_type",
                      e.target.value
                    )
                  }
                >
                  {payerTypes.map((p) => (
                    <option
                      key={p.value}
                      value={p.value}
                    >
                      {p.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>

                {row.payer_type === "CUSTOMER" ? (

                  <AsyncSearchSelect
                    placeholder="Search customer..."
                    loadOptions={
                      lookupService.searchCustomers
                    }
                    labelKey="name"
                    valueKey="id"
                    value={
                      row.customer_id
                        ? {
                            id: row.customer_id,
                            name: row.customer_name || ""
                          }
                        : null
                    }
                    onChange={(selected) => {

                      updateRow(
                        index,
                        "customer_id",
                        selected?.id || null
                      );

                      updateRow(
                        index,
                        "customer_name",
                        selected?.name || ""
                      );

                    }}
                  />

                ) : (

                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value=""
                  />

                )}
              </td>

              <td>
                <input
                  type="number"
                  className="form-control"
                  value={row.gst_rate}
                  onChange={(e) =>
                    updateRow(
                      index,
                      "gst_rate",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control"
                  value={row.charge_amount}
                  onChange={(e) =>
                    updateRow(
                      index,
                      "charge_amount",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <input
                  type="text"
                  className="form-control"
                  value={row.remarks}
                  onChange={(e) =>
                    updateRow(
                      index,
                      "remarks",
                      e.target.value
                    )
                  }
                />
              </td>

              <td>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() =>
                    removeRow(index)
                  }
                >
                  X
                </button>
              </td>

            </tr>

          ))}

        </tbody>
      </table>

    </div>
  );
};

export default POChargeTable;